// QR codes for "Take this tour home" and the share box. Dark modules become one SVG path,
// so the code stays sharp at any size; qrPng draws the same code for downloads.
import qrcode from './vendor/qrcode.js';

function make(text: string) {
  const q = qrcode(0, 'M'); // version picked to fit
  q.addData(text);
  q.make();
  return q;
}

/** An SVG of the code with a quiet zone of `margin` modules. */
export function qrSvg(text: string, opts: { margin?: number; dark?: string; light?: string; title?: string } = {}): string {
  const q = make(text);
  const n = q.getModuleCount(), m = opts.margin ?? 2, size = n + m * 2;
  let d = '';
  for (let r = 0; r < n; r++) for (let c = 0; c < n; c++) if (q.isDark(r, c)) d += `M${c + m} ${r + m}h1v1h-1z`;
  const title = opts.title ? `<title>${opts.title.replace(/[<&]/g, '')}</title>` : '';
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${size} ${size}" shape-rendering="crispEdges" role="img">${title}`
    + `<rect width="${size}" height="${size}" fill="${opts.light ?? '#fff'}"/><path d="${d}" fill="${opts.dark ?? '#000'}"/></svg>`;
}

/** A PNG of the code, `px` pixels square, for printing on signage. */
export function qrPng(text: string, px = 1024, opts: { margin?: number; dark?: string } = {}): Promise<Blob> {
  const q = make(text);
  const n = q.getModuleCount(), m = opts.margin ?? 4, cell = Math.floor(px / (n + m * 2));
  const c = document.createElement('canvas'); c.width = c.height = cell * (n + m * 2);
  const g = c.getContext('2d')!;
  g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height);
  g.fillStyle = opts.dark ?? '#000';
  for (let r = 0; r < n; r++) for (let col = 0; col < n; col++) if (q.isDark(r, col)) g.fillRect((col + m) * cell, (r + m) * cell, cell, cell);
  return new Promise((res, rej) => c.toBlob((b) => (b ? res(b) : rej(new Error('Couldn’t draw the QR code'))), 'image/png'));
}
